// extracted by mini-css-extract-plugin
export default {"scoreContainer":"ScoreBox_scoreContainer__chJ1D","score":"ScoreBox_score__+GbEP"};